import { faYoutube, faYoutubeSquare } from "@fortawesome/free-brands-svg-icons";
import { faGithub } from "@fortawesome/free-brands-svg-icons/faGithub";
import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons/faLinkedinIn";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons/faEnvelope";

const data = [
  {
    link: "https://github.com/constantinirimia",
    label: "Github",
    icon: faGithub,
  },
  {
    link: "https://www.linkedin.com/in/constantin-irimia/",
    label: "LinkedIn",
    icon: faLinkedinIn,
  },
  {
    link: "https://www.youtube.com/channel/UC-HHxlBILQUFDKMkaoSRPPg",
    label: "Youtube",
    icon: faYoutube,
  },
  {
    link: "mailto:cirimia100@gmail.com",
    label: "Email",
    icon: faEnvelope,
  },
];

export default data;
